(() => {
  const root = document.getElementById('qs-mixed');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const base = window.Shopify?.routes?.root || '/';
  const config = {
    duo: { handle: 'kit-com-5-un-quick-stick-protein-duo', variant: '41671247986763', count: 5, name: 'Mix Duo', flavors: 'Original + Churrasco', intro: 'Dois sabores de carne bovina para variar seu Quick.', image: 'https://cdn.shopify.com/s/files/1/0607/1982/4971/files/duo5_d47a2fda-704b-4bf3-be72-b065da607fe2.jpg?v=1771966093' },
    trio: { handle: 'kit-com-6-un-quick-stick-protein-trio', variant: '41957533745227', count: 6, name: 'Mix Trio', flavors: 'Original + Churrasco + Frango', intro: 'Os três sabores da linha Quick Stick em um só kit.', image: 'https://cdn.shopify.com/s/files/1/0607/1982/4971/files/kit6.jpg?v=1771612599' }
  };
  const money = cents => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
  const find = selector => root.querySelector(selector);
  let kit = 'duo', recurring = false, busy = false, completed = false;
  const data = {};
  let selectedPlan = null, selectedDays = 30;
  const planDays = plan => Number(plan.name.match(/(15|30|45)\s*dias?/i)?.[1] || 0);
  const picker = find('[data-frequency-picker]');
  const quantity = () => Number(find('[name="quantity"]').value);
  async function getProduct(key) {
    const response = await fetch(base + 'products/' + config[key].handle + '.js', { cache: 'no-store' });
    if (!response.ok) throw new Error('Não foi possível consultar este kit. Tente novamente.');
    const product = await response.json();
    const variant = product.variants.find(item => String(item.id) === config[key].variant);
    if (!variant) throw new Error('Este kit não está disponível.');
    const plans = (product.selling_plan_groups || []).flatMap(group => group.selling_plans || []);
    const availablePlans = plans.filter(plan => planDays(plan) && variant.selling_plan_allocations?.some(a => String(a.selling_plan_id) === String(plan.id))).sort((a,b) => planDays(a)-planDays(b));
    const monthly = availablePlans.find(plan => planDays(plan) === selectedDays) || availablePlans.find(plan => planDays(plan) === 30) || availablePlans[0];
    const allocation = variant.selling_plan_allocations?.find(item => String(item.selling_plan_id) === String(monthly?.id));
    return { product, variant, plans: availablePlans, monthly: allocation ? monthly : null, allocation };
  }
  function render() {
    const cfg = config[kit], current = data[kit];
    if (current) {
      current.monthly = current.plans.find(p => planDays(p) === selectedDays) || current.plans.find(p => planDays(p) === 30) || current.plans[0];
      current.allocation = current.variant.selling_plan_allocations?.find(a => String(a.selling_plan_id) === String(current.monthly?.id));
      if (current.monthly) selectedDays = planDays(current.monthly);
      picker.replaceChildren(...current.plans.map(plan => {const option = document.createElement('option'); option.value = String(plan.id); option.textContent = 'A cada '+planDays(plan)+' dias'; return option;}));
      picker.value = String(current.monthly?.id || '');
    }
    picker.disabled = busy || !current?.plans.length;
    root.querySelectorAll('[name="kit"]').forEach(input => { input.checked = input.value === kit; input.disabled = busy; });
    find('[data-kit-name]').textContent = cfg.name;
    find('[data-kit-size]').textContent = cfg.count + ' sticks · 18 g por unidade';
    find('[data-kit-intro]').textContent = cfg.intro;
    find('[data-meat-info]').textContent = kit === 'trio' ? 'Carne bovina + frango' : 'Carne bovina';
    find('[data-protein-info]').textContent = kit === 'trio' ? '5 g bovinos · 6 g frango' : '5 g de proteína por stick';
    find('[data-protein-tile]').textContent = kit === 'trio' ? '5 g bovinos · 6 g frango' : '5 g de proteína';
    find('[data-protein-note]').textContent = 'por stick de 18 g';
    find('[data-flavors]').textContent = cfg.flavors;
    find('[data-contents]').textContent = cfg.count + ' sticks nos sabores ' + cfg.flavors.replaceAll(' + ', ', ') + '.';
    find('[data-main-photo]').src = cfg.image;
    find('[data-main-photo]').alt = 'Kit Quick Stick ' + cfg.name + ' com ' + cfg.count + ' sticks';
    find('[data-photo-caption]').textContent = cfg.name + ' · ' + cfg.count + ' sticks';
    find('[name="id"]').value = cfg.variant;
    const subscriptionInput = find('[value="monthly"]');
    subscriptionInput.disabled = busy || !current?.monthly || !current?.variant.available;
    if (!current?.monthly) recurring = false;
    const requiresPlan = !!(current?.product.requires_selling_plan || current?.variant.requires_selling_plan);
    if (requiresPlan && current?.monthly) recurring = true;
    find('[value="once"]').closest('label').hidden = requiresPlan;
    find('[value="once"]').checked = !recurring;
    subscriptionInput.checked = recurring;
    find('[value="once"]').disabled = busy || requiresPlan;
    find('[data-sub-info]').hidden = !recurring;
    find('[data-chicken-info]').hidden = kit !== 'trio';
    find('[data-plan-caption]').textContent = recurring ? 'Por kit, a cada '+selectedDays+' dias.' : 'Por kit, em compra única.';
    selectedPlan = recurring && current?.monthly ? String(current.monthly.id) : null;
    find('[name="selling_plan"]').disabled = !selectedPlan;
    find('[name="selling_plan"]').value = selectedPlan || '';
    find('[name="quantity"]').disabled = busy;
    root.querySelectorAll('[data-quantity-step]').forEach(button => { button.disabled = busy || completed; });
    const submit = find('[type="submit"]');
    submit.disabled = busy || completed || !current || !current.variant.available;
    if (!current) {
      find('[data-price]').textContent = 'Consultando…';
      find('[data-unit]').textContent = '';
      submit.textContent = 'Consultando disponibilidade…';
      return;
    }
    const amount = recurring ? current.allocation.price : current.variant.price;
    find('[data-price]').textContent = money(amount);
    find('[data-unit]').textContent = money(Math.round(amount / cfg.count)) + ' por stick';
    find('[data-compare]').hidden = !recurring || amount >= current.variant.price;
    find('[data-compare]').textContent = money(current.variant.price);
    find('[data-once-price]').textContent = money(current.variant.price);
    find('[data-monthly-price]').textContent = current.allocation ? money(current.allocation.price) : 'Indisponível';
    const discount = current.allocation && current.variant.price > 0 ? Math.round((1 - current.allocation.price / current.variant.price) * 100) : 0;
    find('[data-save]').textContent = discount > 0 ? discount + '% OFF' : 'Assinatura';
    find('[data-plan-compare]').textContent = money(current.variant.price);
    find('[data-plan-compare]').hidden = !discount;
    find('[data-qty-caption]').textContent = quantity() + ' ' + (quantity() === 1 ? 'kit' : 'kits') + ' · ' + (quantity() * cfg.count) + ' sticks por ' + (recurring ? 'entrega' : 'pedido');
    submit.textContent = completed ? 'Adicionado ao carrinho' : busy ? 'Adicionando…' : !current.variant.available ? 'Indisponível no momento' : money(amount * quantity()) + ' • ' + (recurring ? 'Adicionar assinatura' : 'Adicionar ao carrinho');
  }
  root.querySelectorAll('[data-open-nutrition]').forEach(link => link.addEventListener('click', () => { find('#qm-nutrition').open = true; }));
  root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
    if (busy || completed) return;
    find('[name="quantity"]').value = String(Math.max(1, Math.min(99, (quantity() || 1) + Number(button.dataset.quantityStep))));
    render();
  }));
  root.querySelectorAll('[name="kit"]').forEach(input => input.addEventListener('change', () => {
    if (busy) return;
    kit = input.value;
    find('[data-feedback]').textContent = '';
    const url = new URL(window.location.href);
    url.searchParams.set('kit', kit);
    window.history.replaceState({}, '', url);
    render();
  }));
  picker.addEventListener('change', () => {
    const plan = data[kit]?.plans.find(p => String(p.id) === picker.value);
    if (!plan || busy) return;
    selectedDays = planDays(plan); recurring = true; render();
  });
  root.querySelectorAll('[name="purchase"]').forEach(input => input.addEventListener('change', () => {
    if (busy) return;
    recurring = input.value === 'monthly';
    find('[data-feedback]').textContent = '';
    render();
  }));
  find('[name="quantity"]').addEventListener('input', () => {
    if (find('[name="quantity"]').validity.valid) render();
  });
  find('[name="quantity"]').addEventListener('blur', () => {
    if (!find('[name="quantity"]').validity.valid) find('[name="quantity"]').value = '1';
    render();
  });
  find('form').addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || completed || !data[kit] || !event.currentTarget.reportValidity()) return;
    const chosenKit = kit, chosenRecurring = recurring, chosenQuantity = quantity(), expectedPlan = selectedPlan;
    const expectedPrice = chosenRecurring ? data[kit].allocation.price : data[kit].variant.price;
    busy = true;
    render();
    const feedback = find('[data-feedback]');
    feedback.textContent = '';
    try {
      const fresh = await getProduct(chosenKit);
      data[chosenKit] = fresh;
      if (!chosenRecurring && (fresh.product.requires_selling_plan || fresh.variant.requires_selling_plan)) throw new Error('Este kit está disponível por assinatura. Confira o plano selecionado.');
      if (!fresh.variant.available) throw new Error('Este kit ficou indisponível. Escolha outra opção.');
      if (chosenRecurring && (!fresh.monthly || String(fresh.monthly.id) !== expectedPlan)) throw new Error('A assinatura foi atualizada. Confira as opções antes de continuar.');
      const price = chosenRecurring ? fresh.allocation.price : fresh.variant.price;
      if (price !== expectedPrice) throw new Error('O preço foi atualizado. Confira o novo valor e clique novamente para adicionar.');
      const payload = { id: config[chosenKit].variant, quantity: chosenQuantity };
      if (expectedPlan) payload.selling_plan = expectedPlan;
      const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Não foi possível adicionar. Tente novamente.');
      completed = true;
      find('[data-cart-link]').hidden = false;
      const item = result.items?.[0] || result;
      if (expectedPlan && String(item.selling_plan_allocation?.selling_plan?.id) !== expectedPlan) {
        feedback.textContent = 'O item foi adicionado. Confira o plano no carrinho antes de finalizar.';
      } else {
        window.location.assign(base + 'cart');
      }
    } catch (error) {
      feedback.textContent = error.message;
    } finally {
      busy = false;
      render();
    }
  });
  const initial = new URL(window.location.href).searchParams.get('kit');
  if (initial && config[initial]) kit = initial;
  render();
  Promise.allSettled(Object.keys(config).map(async key => {
    try {
      data[key] = await getProduct(key);
      render();
    } catch (error) {
      if (kit === key) {
        find('[data-feedback]').textContent = error.message + ' Você também pode consultar o outro kit.';
        find('[type="submit"]').textContent = 'Consulta indisponível';
      }
    }
  }));
})();
